// Bilingual content — English (en) and Kannada (kn)
export const PHASES = [
  { en: "Personal Details", kn: "ವೈಯಕ್ತಿಕ ವಿವರಗಳು" },
  { en: "Church & Ministry", kn: "ಚರ್ಚ್ ಮತ್ತು ಸೇವೆಯ ವಿವರಗಳು" },
  { en: "Family Details", kn: "ಕುಟುಂಬದ ವಿವರಗಳು" },
  { en: "Payment", kn: "ಪಾವತಿ ವಿವರಗಳು" },
  { en: "Travel Assistance", kn: "ಪ್ರತಿನಿಧಿಗಳ ಸಹಾಯ" },
  { en: "Declaration & Submit", kn: "ಘೋಷಣೆ ಮತ್ತು ಮಾರ್ಗಸೂಚಿಗಳು" },
];

export const T = {
  nav: {
    details: { en: "Details", kn: "ವಿವರಗಳು" },
    speakers: { en: "Speakers", kn: "ವಕ್ತಾರರು" },
    worship: { en: "Worship", kn: "ಆರಾಧನೆ" },
    fee: { en: "Fee", kn: "ಶುಲ್ಕ" },
    contact: { en: "Contact", kn: "ಸಂಪರ್ಕ" },
    register: { en: "Register Now", kn: "ಈಗ ನೋಂದಾಯಿಸಿ" },
  },
  hero: {
    eyebrow: { en: "Glory Conference", kn: "ಗ್ಲೋರಿ ಸಮಾವೇಶ" },
    theme: { en: "Dimensions of the Prophetic Realms", kn: "ಪ್ರವಾದನಾತ್ಮಕ ಲೋಕಗಳ ಆಯಾಮಗಳು" },
    support: { en: "Three Days of Worship, the Word and Spiritual Encounters.", kn: "ಮೂರು ದಿನಗಳ ಆರಾಧನೆ, ವಾಕ್ಯ ಮತ್ತು ಆತ್ಮಿಕ ಅನುಭವಗಳು." },
    dates: { en: "10 – 12 December 2026", kn: "೧೦ – ೧೨ ಡಿಸೆಂಬರ್ ೨೦೨೬" },
    venue: { en: "Marthoma Camp Centre, Devanahalli, Bangalore", kn: "ಮಾರ್ಥೋಮಾ ಕ್ಯಾಂಪ್ ಸೆಂಟರ್, ದೇವನಹಳ್ಳಿ, ಬೆಂಗಳೂರು" },
    ctaPrimary: { en: "Register Now", kn: "ಈಗ ನೋಂದಾಯಿಸಿ" },
    ctaSecondary: { en: "View Conference Details", kn: "ಸಮಾವೇಶದ ವಿವರಗಳು ನೋಡಿ" },
    city: { en: "Bangalore", kn: "ಬೆಂಗಳೂರು" },
  },
  details: {
    heading: { en: "Conference Details", kn: "ಸಮಾವೇಶದ ವಿವರಗಳು" },
    sub: { en: "Everything you need to plan your visit", kn: "ನಿಮ್ಮ ಭೇಟಿಯನ್ನು ಯೋಜಿಸಲು ಬೇಕಾದ ಎಲ್ಲಾ ಮಾಹಿತಿ" },
    dates: { en: "Dates", kn: "ದಿನಾಂಕಗಳು" },
    datesVal: { en: "10, 11 & 12 December 2026", kn: "೧೦, ೧೧ ಮತ್ತು ೧೨ ಡಿಸೆಂಬರ್ ೨೦೨೬" },
    days: { en: "Days", kn: "ದಿನಗಳು" },
    daysVal: { en: "Thursday, Friday & Saturday", kn: "ಗುರುವಾರ, ಶುಕ್ರವಾರ ಮತ್ತು ಶನಿವಾರ" },
    time: { en: "Time", kn: "ಸಮಯ" },
    timeVal: { en: "9:00 AM – 6:00 PM", kn: "ಬೆಳಿಗ್ಗೆ ೯:೦೦ – ಸಂಜೆ ೬:೦೦" },
    venue: { en: "Venue", kn: "ಸ್ಥಳ" },
    venueVal: { en: "Marthoma Camp Centre, National Highway 207, Devanahalli, Bangalore, Karnataka – 562110", kn: "ಮಾರ್ಥೋಮಾ ಕ್ಯಾಂಪ್ ಸೆಂಟರ್, ರಾಷ್ಟ್ರೀಯ ಹೆದ್ದಾರಿ ೨೦೭, ದೇವನಹಳ್ಳಿ, ಬೆಂಗಳೂರು, ಕರ್ನಾಟಕ – ೫೬೨೧೧೦" },
    directions: { en: "Get Directions", kn: "ದಾರಿ ಪಡೆಯಿರಿ" },
  },
  speakers: {
    heading: { en: "Speakers", kn: "ವಕ್ತಾರರು" },
    sub: { en: "The Word that transforms", kn: "ಪರಿವರ್ತಿಸುವ ವಾಕ್ಯ" },
    mainBadge: { en: "Main Speaker", kn: "ಮುಖ್ಯ ವಕ್ತಾರ" },
    translatorBadge: { en: "Translator", kn: "ಅನುವಾದಕ" },
  },
  worship: {
    heading: { en: "Worship", kn: "ಆರಾಧನೆ" },
    sub: { en: "Leading us into His presence", kn: "ಆತನ ಸನ್ನಿಧಿಗೆ ನಮ್ಮನ್ನು ನಡೆಸುವವರು" },
  },
  fee: {
    heading: { en: "Registration", kn: "ನೋಂದಣಿ" },
    sub: { en: "One registration covers one individual", kn: "ಒಂದು ನೋಂದಣಿಯು ಒಬ್ಬ ವ್ಯಕ್ತಿಗೆ ಮಾತ್ರ" },
    price: { en: "₹1,000", kn: "₹೧,೦೦೦" },
    perPerson: { en: "per person", kn: "ಪ್ರತಿ ವ್ಯಕ್ತಿಗೆ" },
    includes: { en: "Includes conference entrance and lunch for all three days", kn: "ಮೂರು ದಿನಗಳ ಸಮಾವೇಶದ ಪ್ರವೇಶ ಮತ್ತು ಮಧ್ಯಾಹ್ನದ ಊಟವನ್ನು ಒಳಗೊಂಡಿರುತ್ತದೆ" },
    note1: { en: "Registration is charged separately for each person.", kn: "ಪ್ರತಿಯೊಬ್ಬರೂ ಪ್ರತ್ಯೇಕವಾಗಿ ನೋಂದಣಿ ಶುಲ್ಕವನ್ನು ಪಾವತಿಸಬೇಕು." },
    note2: { en: "One registration covers one individual.", kn: "ಒಂದು ನೋಂದಣಿಯು ಒಬ್ಬ ವ್ಯಕ್ತಿಗೆ ಮಾತ್ರ ಅನ್ವಯಿಸುತ್ತದೆ." },
    note3: { en: "Registration is confirmed only after payment verification.", kn: "ಶುಲ್ಕ ಪಾವತಿಯನ್ನು ಪರಿಶೀಲಿಸಿದ ನಂತರವೇ ನೋಂದಣಿ ದೃಢೀಕರಿಸಲಾಗುತ್ತದೆ." },
    cta: { en: "Register Now", kn: "ಈಗ ನೋಂದಾಯಿಸಿ" },
  },
  form: {
    heading: { en: "Register for the Conference", kn: "ಸಮಾವೇಶಕ್ಕೆ ನೋಂದಾಯಿಸಿ" },
    sub: { en: "Complete the six simple steps below", kn: "ಕೆಳಗಿನ ಆರು ಸರಳ ಹಂತಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ" },
    stepOf: { en: "Step", kn: "ಹಂತ" },
    of: { en: "of", kn: "ರಲ್ಲಿ" },
    back: { en: "Back", kn: "ಹಿಂದೆ" },
    continue: { en: "Continue", kn: "ಮುಂದುವರಿಸಿ" },
    submit: { en: "Submit Registration", kn: "ನೋಂದಣಿಯನ್ನು ಸಲ್ಲಿಸಿ" },
    submitting: { en: "Submitting…", kn: "ಸಲ್ಲಿಸಲಾಗುತ್ತಿದೆ…" },
    requiredNote: { en: "Fields marked * are required", kn: "* ಗುರುತಿನ ಕ್ಷೇತ್ರಗಳು ಕಡ್ಡಾಯ" },
  },
  p1: {
    title: { en: "Personal Details", kn: "ಹಂತ 1 – ವೈಯಕ್ತಿಕ ವಿವರಗಳು" },
    fullName: { en: "Full Name", kn: "ಹೆಸರು" },
    gender: { en: "Gender", kn: "ಲಿಂಗ" },
    male: { en: "Male", kn: "ಪುರುಷ" },
    female: { en: "Female", kn: "ಮಹಿಳೆ" },
    age: { en: "Age", kn: "ವಯಸ್ಸು" },
    dob: { en: "Date of Birth", kn: "ಜನ್ಮ ದಿನಾಂಕ" },
    mobile: { en: "Mobile Number (WhatsApp)", kn: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ (ವಾಟ್ಸಾಪ್)" },
    email: { en: "Email Address", kn: "ಇಮೇಲ್ ವಿಳಾಸ" },
    address: { en: "Full Address", kn: "ಪೂರ್ಣ ವಿಳಾಸ" },
    state: { en: "State", kn: "ರಾಜ್ಯ" },
    country: { en: "Country", kn: "ದೇಶ" },
    pickDate: { en: "Pick a date", kn: "ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆಮಾಡಿ" },
  },
  p2: {
    title: { en: "Church & Ministry Details", kn: "ಹಂತ 2 – ಚರ್ಚ್ ಮತ್ತು ಸೇವೆಯ ವಿವರಗಳು" },
    churchName: { en: "Church / Organization Name", kn: "ಚರ್ಚ್ / ಸಂಸ್ಥೆಯ ಹೆಸರು" },
    designation: { en: "Designation", kn: "ಹುದ್ದೆ" },
    otherSpecify: { en: "Please specify", kn: "ದಯವಿಟ್ಟು ತಿಳಿಸಿ" },
    reference: { en: "How did you hear about the conference? / Reference Name", kn: "ಈ ಸಮಾವೇಶದ ಬಗ್ಗೆ ನಿಮಗೆ ಹೇಗೆ ತಿಳಿಯಿತು? / ಶಿಫಾರಸು ಮಾಡಿದವರ ಹೆಸರು (ಇದ್ದರೆ)" },
    options: [
      { en: "Pastor", kn: "ಪಾಸ್ಟರ್" },
      { en: "Evangelist", kn: "ಸುವಾರ್ತಿಕ" },
      { en: "Missionary", kn: "ಮಿಷನರಿ" },
      { en: "Church Leader", kn: "ಚರ್ಚಿನ ನಾಯಕ" },
      { en: "Student (Undergraduate / Postgraduate)", kn: "ವಿದ್ಯಾರ್ಥಿ / ವಿದ್ಯಾರ್ಥಿನಿ" },
      { en: "Business Professional", kn: "ವ್ಯವಹಾರ ವೃತ್ತಿಪರ" },
      { en: "Employee", kn: "ಉದ್ಯೋಗಿ" },
      { en: "Member", kn: "ಸದಸ್ಯ" },
      { en: "Other", kn: "Other" },
    ],
  },
  p3: {
    title: { en: "Family Details", kn: "ಹಂತ 3 – ಕುಟುಂಬದ ವಿವರಗಳು" },
    familyQ: { en: "Are you attending as a family?", kn: "ನೀವು ಕುಟುಂಬ ಸಮೇತರಾಗಿ ಭಾಗವಹಿಸುತ್ತಿದ್ದೀರಾ?" },
    whoQ: { en: "Who is attending with you?", kn: "ನಿಮ್ಮೊಂದಿಗೆ ಯಾರು ಭಾಗವಹಿಸುತ್ತಿದ್ದಾರೆ?" },
    spouse: { en: "Spouse", kn: "ಪತಿ / ಭಾರ್ಯ" },
    children: { en: "Children", kn: "ಮಕ್ಕಳು" },
    parents: { en: "Parents", kn: "ಪೋಷಕರು" },
    memberName: { en: "Name", kn: "ಹೆಸರು" },
    memberAge: { en: "Age", kn: "ವಯಸ್ಸು" },
    memberGender: { en: "Gender", kn: "ಲಿಂಗ" },
    male: { en: "Male", kn: "ಪುರುಷ" },
    female: { en: "Female", kn: "ಮಹಿಳೆ" },
    addChild: { en: "Add another child", kn: "ಮತ್ತೊಂದು ಮಗುವನ್ನು ಸೇರಿಸಿ" },
    addParent: { en: "Add another parent", kn: "ಮತ್ತೊಬ್ಬ ಪೋಷಕರನ್ನು ಸೇರಿಸಿ" },
    remove: { en: "Remove", kn: "ತೆಗೆದುಹಾಕಿ" },
    detailsNote: { en: "Please provide the name, age and gender of each attending family member.", kn: "ದಯವಿಟ್ಟು ಭಾಗವಹಿಸುವ ಪ್ರತಿಯೊಬ್ಬ ಕುಟುಂಬ ಸದಸ್ಯರ ಹೆಸರು, ವಯಸ್ಸು ಮತ್ತು ಲಿಂಗವನ್ನು ತಿಳಿಸಿ." },
    yes: { en: "Yes", kn: "ಹೌದು" },
    no: { en: "No", kn: "ಇಲ್ಲ" },
    feeReminder: { en: "Every individual, including children who are attending, requires a separate ₹1,000 registration.", kn: "ಭಾಗವಹಿಸುವ ಮಕ್ಕಳು ಸೇರಿದಂತೆ ಪ್ರತಿಯೊಬ್ಬರೂ ಪ್ರತ್ಯೇಕವಾಗಿ ₹1,000 ನೋಂದಣಿ ಮಾಡಬೇಕು." },
  },
  p4: {
    title: { en: "Payment Details", kn: "ಹಂತ 4 – ಪಾವತಿ ವಿವರಗಳು" },
    feeLabel: { en: "Registration Fee: ₹1,000 per person", kn: "ಪ್ರತಿ ವ್ಯಕ್ತಿಗೆ ನೋಂದಣಿ ಶುಲ್ಕ ₹1000/-" },
    feeIncludes: { en: "Includes conference entrance and lunch for all three days.", kn: "(ಮೂರು ದಿನಗಳ ಸಮಾವೇಶದ ಪ್ರವೇಶ ಮತ್ತು ಮಧ್ಯಾಹ್ನದ ಊಟವನ್ನು ಒಳಗೊಂಡಿರುತ್ತದೆ.)" },
    totalCandidates: { en: "Total candidates", kn: "ಒಟ್ಟು ಅಭ್ಯರ್ಥಿಗಳು" },
    totalFee: { en: "Total registration fee", kn: "ಒಟ್ಟು ನೋಂದಣಿ ಶುಲ್ಕ" },
    mentionLabel: { en: "While making the UPI payment, please mention this in the payment note / remarks:", kn: "UPI ಪಾವತಿ ಮಾಡುವಾಗ, ದಯವಿಟ್ಟು ಪಾವತಿ ಟಿಪ್ಪಣಿ / ರಿಮಾರ್ಕ್‌ನಲ್ಲಿ ಇದನ್ನು ಉಲ್ಲೇಖಿಸಿ:" },
    scanHere: { en: "Scan with any UPI app to pay", kn: "ಪಾವತಿಸಲು ಯಾವುದೇ UPI ಆ್ಯಪ್‌ನಿಂದ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ" },
    accountName: { en: "Payment account name", kn: "ಪಾವತಿ ಖಾತೆಯ ಹೆಸರು" },
    completedQ: { en: "Have you completed the registration fee payment?", kn: "ನೀವು ನೋಂದಣಿ ಶುಲ್ಕದ ಪಾವತಿಯನ್ನು ಪೂರ್ಣಗೊಳಿಸಿದ್ದೀರಾ?" },
    yes: { en: "Yes", kn: "ಹೌದು" },
    no: { en: "No", kn: "ಇಲ್ಲ" },
    uploadLabel: { en: "Upload your payment screenshot", kn: "ಪಾವತಿ ಮಾಡಿದ ಸ್ಕ್ರೀನ್‌ಶಾಟ್ ಅನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ." },
    uploadHint: { en: "PNG, JPG, WEBP or PDF — max 15 MB", kn: "PNG, JPG, WEBP ಅಥವಾ PDF — ಗರಿಷ್ಠ 15 MB" },
    uploadRequired: { en: "upload is required to continue", kn: "ಮುಂದುವರಿಯಲು ಅಪ್‌ಲೋಡ್ ಕಡ್ಡಾಯ" },
    uploading: { en: "Uploading…", kn: "ಅಪ್‌ಲೋಡ್ ಆಗುತ್ತಿದೆ…" },
    uploaded: { en: "Uploaded successfully", kn: "ಯಶಸ್ವಿಯಾಗಿ ಅಪ್‌ಲೋಡ್ ಆಗಿದೆ" },
    removeFile: { en: "Remove file", kn: "ಫೈಲ್ ತೆಗೆದುಹಾಕಿ" },
    payLaterNote: { en: "Please complete the payment using the QR code above, then upload the payment screenshot below to proceed.", kn: "ದಯವಿಟ್ಟು ಮೇಲಿನ QR ಕೋಡ್ ಬಳಸಿ ಪಾವತಿಯನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ, ನಂತರ ಮುಂದುವರಿಯಲು ಕೆಳಗೆ ಪಾವತಿ ಸ್ಕ್ರೀನ್‌ಶಾಟ್ ಅನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ." },
  },
  p5: {
    title: { en: "Delegate Assistance", kn: "ಹಂತ 5 – ಪ್ರತಿನಿಧಿಗಳ ಸಹಾಯ" },
    welcome: { en: "Travelling from outside Bangalore? We would love to help.", kn: "ಬೆಂಗಳೂರಿನಿಂದ ಹೊರಗಿನಿಂದ ಬರುತ್ತಿದ್ದೀರಾ? ನಾವು ಸಹಾಯ ಮಾಡಲು ಇಷ್ಟಪಡುತ್ತೇವೆ." },
    outsideQ: { en: "Are you travelling from outside Bangalore?", kn: "ನೀವು ಬೆಂಗಳೂರಿನಿಂದ ಹೊರಗಿನಿಂದ ಪ್ರಯಾಣಿಸಿ ಬರುತ್ತಿದ್ದೀರಾ?" },
    accomQ: { en: "Do you require accommodation assistance?", kn: "ನಿಮಗೆ ವಸತಿ ವ್ಯವಸ್ಥೆಗೆ ಸಹಾಯ ಬೇಕೇ?" },
    arrival: { en: "Arrival Date & Time", kn: "ಆಗಮನದ ದಿನಾಂಕ ಮತ್ತು ಸಮಯ" },
    departure: { en: "Departure Date & Time", kn: "ನಿರ್ಗಮಿಸುವ ದಿನಾಂಕ ಮತ್ತು ಸಮಯ" },
    note: { en: "Your travel information helps our team coordinate assistance. Accommodation is subject to confirmation by the organizing team.", kn: "ನಿಮ್ಮ ಪ್ರಯಾಣದ ಮಾಹಿತಿಯು ನಮ್ಮ ತಂಡಕ್ಕೆ ಸಹಾಯವನ್ನು ಸಂಯೋಜಿಸಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ. ವಸತಿಯು ಆಯೋಜಕ ತಂಡದ ದೃಢೀಕರಣಕ್ಕೆ ಒಳಪಟ್ಟಿರುತ್ತದೆ." },
    accomTypeQ: { en: "Choose your accommodation option", kn: "ನಿಮ್ಮ ವಸತಿ ಆಯ್ಕೆಯನ್ನು ಆರಿಸಿ" },
    dorm: { en: "In-Campus Dormitory", kn: "ಒಳಾಂಗಣ ಡಾರ್ಮಿಟರಿ" },
    dormPrice: { en: "₹1,500 per person", kn: "ಪ್ರತಿ ವ್ಯಕ್ತಿಗೆ ₹1,500" },
    dormIncludes: { en: "Includes stay, breakfast and dinner for all 3 days.", kn: "ಮೂರು ದಿನಗಳ ವಸತಿ, ಬೆಳಗಿನ ಊಟ ಮತ್ತು ರಾತ್ರಿಯ ಊಟವನ್ನು ಒಳಗೊಂಡಿರುತ್ತದೆ." },
    hotel: { en: "Outside Hotel / Airbnb", kn: "ಹೊರಗಿನ ಹೋಟೆಲ್ / ಏರ್ಬಿಎನ್‌ಬಿ" },
    hotelNote: { en: "Our team will connect with you to guide you regarding the nearest hotels. Travel and stay costs will be borne by the registrant.", kn: "ಹತ್ತಿರದ ಹೋಟೆಲ್‌ಗಳ ಬಗ್ಗೆ ಮಾರ್ಗದರ್ಶನ ನೀಡಲು ನಮ್ಮ ತಂಡ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸುತ್ತದೆ. ಪ್ರಯಾಣ ಮತ್ತು ವಸತಿ ಖರ್ಚನ್ನು ನೋಂದಾಯಿತರು ಭರಿಸಬೇಕು." },
    dormFeeTitle: { en: "Dormitory stay fee", kn: "ಡಾರ್ಮಿಟರಿ ವಸತಿ ಶುಲ್ಕ" },
    stayUploadLabel: { en: "Upload your stay payment screenshot", kn: "ನಿಮ್ಮ ವಸತಿ ಪಾವತಿಯ ಸ್ಕ್ರೀನ್‌ಶಾಟ್ ಅನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ" },
    selectLanguage: { en: "Select language", kn: "ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ" },
  },
  p6: {
    title: { en: "Declaration & Guidelines", kn: "ಹಂತ 6 – ಘೋಷಣೆ ಮತ್ತು ಮಾರ್ಗಸೂಚಿಗಳು" },
    statements: [
      { en: "I understand that this conference is a Christian faith-based gathering intended for believers and those who voluntarily wish to attend.", kn: "ಈ ಸಮಾವೇಶವು ಕ್ರೈಸ್ತ ನಂಬಿಕೆಯನ್ನು ಆಧರಿಸಿದ ಸಭೆಯಾಗಿದ್ದು, ವಿಶ್ವಾಸಿಗಳಿಗಾಗಿ ಮತ್ತು ಸ್ವಯಂಪ್ರೇರಣೆಯಿಂದ ಭಾಗವಹಿಸಲು ಬಯಸುವವರಿಗಾಗಿ ಆಯೋಜಿಸಲಾದ ಎಂಬುದನ್ನು ನಾನು ಅರ್ಥಮಾಡಿಕೊಂಡಿದ್ದೇನೆ." },
      { en: "I confirm that I am registering of my own free will and that no one has forced, pressured or induced me to attend.", kn: "ನಾನು ನನ್ನ ಸ್ವಂತ ಇಚ್ಛೆಯಿಂದ ನೋಂದಾಯಿಸಿಕೊಳ್ಳುತ್ತಿದ್ದೇನೆ ಮತ್ತು ಭಾಗವಹಿಸಲು ಯಾರೂ ನನ್ನನ್ನು ಒತ್ತಾಯಿಸಿಲ್ಲ, ಒತ್ತಡ ಹೇರಿಲ್ಲ, ಒತ್ತಡ ಹೇರಿಲ್ಲ ಅಥವಾ ಪ್ರಭಾವ ಬೀರಿಲ್ಲ ಎಂಬುದನ್ನು ದೃಢೀಕರಿಸುತ್ತೇನೆ." },
      { en: "I understand that registration is confirmed only after payment verification.", kn: "ಶುಲ್ಕ ಪಾವತಿಯನ್ನು ಪರಿಶೀಲಿಸಿದ ನಂತರವೇ ನೋಂದಣಿ ದೃಢೀಕರಿಸಲಾಗುತ್ತದೆ ಎಂಬುದನ್ನು ನಾನು ಅರ್ಥಮಾಡಿಕೊಂಡಿದ್ದೇನೆ." },
      { en: "I agree to maintain respectful conduct throughout the conference.", kn: "ಸಮಾವೇಶದಾದ್ಯಂತ ಗೌರವಯುತ ಮತ್ತು ಶಿಸ್ತಿನ ವರ್ತನೆಯನ್ನು ಪಾಲಿಸಲು ನಾನು ಒಪ್ಪಿಕೊಳ್ಳುತ್ತೇನೆ." },
    ],
    ackHeading: { en: "Acknowledgement", kn: "ಅಂಗೀಕಾರ" },
    ack: { en: "By submitting this form, I acknowledge and agree to the above terms.", kn: "ಈ ಫಾರ್ಮ್ ಅನ್ನು ಸಲ್ಲಿಸುವ ಮೂಲಕ, ಮೇಲಿನ ಎಲ್ಲಾ ನಿಯಮಗಳನ್ನು ನಾನು ಅರ್ಥಮಾಡಿಕೊಂಡು ಒಪ್ಪಿಕೊಳ್ಳುತ್ತೇನೆ." },
  },
  success: {
    title: { en: "Registration Submitted Successfully!", kn: "ನೋಂದಣಿ ಯಶಸ್ವಿಯಾಗಿ ಸಲ್ಲಿಕೆಯಾಗಿದೆ!" },
    ref: { en: "Your registration reference number", kn: "ನಿಮ್ಮ ನೋಂದಣಿ ಉಲ್ಲೇಖ ಸಂಖ್ಯೆ" },
    note1: { en: "Your registration confirmation is subject to payment verification by the organizing team.", kn: "ಆಯೋಜಕ ತಂಡದ ಪಾವತಿ ಪರಿಶೀಲನೆಗೆ ಒಳಪಟ್ಟು ನಿಮ್ಮ ನೋಂದಣಿ ದೃಢೀಕರಿಸಲಾಗುತ್ತದೆ." },
    note2: { en: "Each attending family member, including children, must register separately.", kn: "ಮಕ್ಕಳು ಸೇರಿದಂತೆ ಭಾಗವಹಿಸುವ ಪ್ರತಿಯೊಬ್ಬ ಕುಟುಂಬ ಸದಸ್ಯರೂ ಪ್ರತ್ಯೇಕವಾಗಿ ನೋಂದಾಯಿಸಿಕೊಳ್ಳಬೇಕು." },
    note3: { en: "For any assistance, contact our coordinators below.", kn: "ಯಾವುದೇ ಸಹಾಯಕ್ಕಾಗಿ, ಕೆಳಗಿನ ನಮ್ಮ ಸಂಯೋಜಕರನ್ನು ಸಂಪರ್ಕಿಸಿ." },
    registerAnother: { en: "Register Another Person", kn: "ಮತ್ತೊಬ್ಬರನ್ನು ನೋಂದಾಯಿಸಿ" },
    backHome: { en: "Back to Top", kn: "ಮೇಲಕ್ಕೆ ಹಿಂತಿರುಗಿ" },
  },
  contact: {
    heading: { en: "Co-ordinators", kn: "ಸಂಯೋಜಕರು" },
    sub: { en: "For any conference information, registration or delegate assistance", kn: "ಯಾವುದೇ ಸಮಾವೇಶದ ಮಾಹಿತಿ, ನೋಂದಣಿ ಅಥವಾ ಪ್ರತಿನಿಧಿ ಸಹಾಯಕ್ಕಾಗಿ" },
    call: { en: "Call", kn: "ಕರೆ ಮಾಡಿ" },
    whatsapp: { en: "WhatsApp", kn: "ವಾಟ್ಸಾಪ್" },
  },
  privacy: {
    heading: { en: "Privacy Notice", kn: "ಗೌಪ್ಯತಾ ಪ್ರಕಟಣೆ" },
    body: { en: "The information you provide — including your personal details, travel preferences and uploaded payment proof — is used solely for organising Glory Conference Bangalore 2026: processing your registration, verifying your payment and arranging delegate assistance. Your data is accessible only to the organising team, is never sold or shared with third parties, and payment screenshots are stored securely and used only for payment verification.", kn: "ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ವಿವರಗಳು, ಪ್ರಯಾಣದ ಆದ್ಯತೆಗಳು ಮತ್ತು ಅಪ್‌ಲೋಡ್ ಮಾಡಿದ ಪಾವತಿ ಪುರಾವೆ ಸೇರಿದಂತೆ ನೀವು ಒದಗಿಸುವ ಮಾಹಿತಿಯನ್ನು ಗ್ಲೋರಿ ಕಾನ್ಫರೆನ್ಸ್ ಬೆಂಗಳೂರು ೨೦೨೬ ಅನ್ನು ಆಯೋಜಿಸಲು ಮಾತ್ರ ಬಳಸಲಾಗುತ್ತದೆ: ನಿಮ್ಮ ನೋಂದಣಿಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲು, ನಿಮ್ಮ ಪಾವತಿಯನ್ನು ಪರಿಶೀಲಿಸಲು ಮತ್ತು ಪ್ರತಿನಿಧಿ ಸಹಾಯವನ್ನು ಏರ್ಪಡಿಸಲು. ನಿಮ್ಮ ಡೇಟಾವನ್ನು ಆಯೋಜಕ ತಂಡಕ್ಕೆ ಮಾತ್ರ ಲಭ್ಯವಿರುತ್ತದೆ, ಎಂದಿಗೂ ಮಾರಾಟ ಮಾಡಲಾಗುವುದಿಲ್ಲ ಅಥವಾ ಮೂರನೇ ವ್ಯಕ್ತಿಗಳೊಂದಿಗೆ ಹಂಚಿಕೊಳ್ಳಲಾಗುವುದಿಲ್ಲ." },
  },
  footer: {
    made: { en: "Glory Conference – Bangalore", kn: "ಗ್ಲೋರಿ ಕಾನ್ಫರೆನ್ಸ್ – ಬೆಂಗಳೂರು" },
  },
  errors: {
    required: { en: "This field is required", kn: "ಈ ಕ್ಷೇತ್ರ ಕಡ್ಡಾಯ" },
    invalidEmail: { en: "Enter a valid email address", kn: "ಮಾನ್ಯವಾದ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ" },
    invalidMobile: { en: "Enter a valid 10-digit mobile number", kn: "ಮಾನ್ಯವಾದ 10-ಅಂಕಿಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ" },
    invalidAge: { en: "Enter a valid age", kn: "ಮಾನ್ಯವಾದ ವಯಸ್ಸನ್ನು ನಮೂದಿಸಿ" },
    uploadFailed: { en: "Upload failed — please try again", kn: "ಅಪ್‌ಲೋಡ್ ವಿಫಲವಾಗಿದೆ — ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ" },
    submitFailed: { en: "Submission failed — please check your details and try again", kn: "ಸಲ್ಲಿಕೆ ವಿಫಲವಾಗಿದೆ — ದಯವಿಟ್ಟು ನಿಮ್ಮ ವಿವರಗಳನ್ನು ಪರಿಶೀಲಿಸಿ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ" },
  },
};

export const SPEAKERS = [
  { name: "Rev. Dr. Babu K Mathew", role: "main" },
  { name: "Pr. John Stephen", role: "translator" },
];

export const WORSHIP_TEAM = ["Br. Joe Ashok", "Br. Sachin Chris", "Br. Nithin"];

export const COORDINATORS = [
  { name: "Pr. Samuel Anish", phone: "+91 95385 81197", tel: "+919538581197" },
  { name: "Pr. Joel Joyson", phone: "+91 93841 61933", tel: "+919384161933" },
];
